import type { Option } from "@/components/MultipleSelector"

export type Pagination = {
  page?: number
  limit?: number
  partnerId?: string
}

export type ApiKey = {
  Id: string
  orgId: string
  Name: string
  bcrypt_hash: string
  CreatedAt: string
}

export type Partner = {
  id: string
  name: string
  comment: string
  created_at: string
  updated_at: string
}

export type PartnerSummary = Partner & {
  subscriber_count: number
  device_count: number
}

export interface Station {
  lat: number
  lon: number
  // Instantaneous health (raw orion_station_healthiness bit). Decoded from the
  // wire's health byte.
  healthy: boolean
  // Rolling-window health as an integer percent (0-100). Decoded from the wire's
  // trailing avg_health byte; only present from format v2 on.
  avgHealth?: number
  // Nominal health: the rolling-average gate SQI actually selects on (7-day
  // AvgHealth >= 50%). Derived from avgHealth; only present from format v2 on.
  nominallyHealthy?: boolean
  // NX (real-time) station. Decoded from the wire's kinds bitfield (bit 0).
  is_nx?: boolean
  // AM-modeling input station. Decoded from the wire's kinds bitfield (bit 1).
  is_am_modeling?: boolean
}

export const isNxStation = (s: Station): boolean => s.is_nx === true
export const isAmModelingStation = (s: Station): boolean =>
  s.is_am_modeling === true

export type UserKratosIdentity = {
  Identity: User
  Sessions: Array<any>
}
// Kratos User
export type User = {
  created_at: string
  id: string
  metadata_public: UserMetadataPublic
  organization_id: any
  recovery_addresses: Array<UserRecoveryAddress>
  schema_id: string
  schema_url: string
  state_changed_at: string
  state: string
  traits: UserTraits
  updated_at: string
  verifiable_addresses: Array<UserVerifiableAddress>
}

export type UserMetadataPublic = {
  org_id: string
  role: string
}

export type UserRecoveryAddress = {
  created_at: string
  id: string
  updated_at: string
  value: string
  via: string
}

export type UserTraits = {
  email: string
  name: UserName
}

export type UserName = {
  first: string
  last: string
}

export interface UserVerifiableAddress {
  created_at: string
  id: string
  status: string
  updated_at: string
  value: string
  verified: boolean
  via: string
}

type ReportType = "fleet" | "devices"

export const initialFormData: FormData = {
  partner_id: "",
  subscriber_id: "all",
  report_type: "fleet",
  from: "",
  to: "",
  columns: [],
}

export interface FormData {
  partner_id: string
  subscriber_id?: string
  report_type: ReportType
  from: string
  to: string
  columns: Array<Option>
}

export interface createUsageReportInput {
  from: string
  to: string
  report: ReportType
  columns: Array<string>
  subscriberId?: string
}

export interface UsageReport {
  account_id: string
  sessionNumber: number
  hour: number
  start_time: string
  country: string
  last_seen: string
  latitude: string
}
